import { usePost } from "./PostProvider";

/**
 * Sélecteur de poste de régulation (F0.6). Rendu uniquement si le réseau
 * organise sa régulation par poste. Composant Bulma (`select`), non redessiné.
 */
export function PostSelector({ compact = false }: { compact?: boolean }) {
  const { posts, hasPosts, activePost, setActivePost } = usePost();
  if (!hasPosts) return null;

  return (
    <div className={`field is-grouped ${compact ? "is-align-items-center" : ""}`} style={{ marginBottom: 0 }}>
      <div className="control">
        {/* Pas d'étiquette « Poste » visible : le libellé des options la porte
            déjà (« Rég. 1 · 2 lignes »). Étiquette accessible conservée. */}
        <div className={`select is-small ${compact ? "" : "is-fullwidth"}`}>
          <label className="is-sr-only" htmlFor="post-selector">
            Poste de régulation
          </label>
          <select
            id="post-selector"
            value={activePost?.id ?? ""}
            onChange={(event) => setActivePost(event.target.value || null)}
          >
            {/* J.12 — « Général » : aucun poste actif, pas de `?post=`, réseau entier. */}
            <option value="">Général · réseau entier</option>
            {posts.map((post) => (
              <option key={post.id} value={post.id}>
                {post.label}
                {post.lineIds.length === 0
                  ? " · réseau entier"
                  : post.lineIds.length === 1
                    ? " · 1 ligne"
                    : ` · ${post.lineIds.length} lignes`}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}
